// import {createRouter, createWebHashHistory} from 'vue-router';
import { createRouter, createWebHistory } from 'vue-router';
import config from '@/config';
import SessionUtil from '@/utils/SessionUtil';
import RouterUtil from '@/utils/RouterUtil';

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'index'
    }
  },
  {
    name: 'index',
    path: '/index',
    component: () => import('./view/pages/index/index'),
    meta: {
      title: config.title,
      keepAlive: true
    }
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('./view/pages/login/login'),
    meta: {
      title: '登录 - ' + config.title
    }
  },
  {
    name: 'address',
    path: '/address',
    component: () => import('./view/pages/address/address'),
    meta: {
      title: '选择地址'
    }
  },
  {
    name: 'address-map-select',
    path: '/address/map-select',
    component: () => import('./view/pages/address/map-select/map-select'),
    meta: {
      title: '选择地址'
    }
  },
  {
    name: 'city',
    path: '/city',
    component: () => import('./view/pages/city/city.vue'),
    meta: {
      title: '选择城市'
    }
  },
  {
    name: 'order-initiate',
    path: '/order/initiate',
    component: () => import('./view/pages/order/initiate/initiate'),
    meta: {
      title: '发起叫车'
    }
  },
  {
    name: 'order-calling',
    path: '/order/calling',
    component: () => import('./view/pages/order/calling/calling'),
    meta: {
      login: true,
      title: '正在呼叫'
    }
  },
  {
    name: 'order-progress',
    path: '/order/progress',
    component: () => import('./view/pages/order/progress/progress'),
    meta: {
      login: true,
      title: '行程服务'
    }
  },
  {
    name: 'order-checkout',
    path: '/order/checkout',
    component: () => import('./view/pages/order/checkout/checkout'),
    meta: {
      login: true,
      title: '待支付'
    }
  },
  {
    name: 'order-finished',
    path: '/order/finished',
    component: () => import('./view/pages/order/finished/finished'),
    meta: {
      login: true,
      title: '行程已结束'
    }
  },
  {
    name: 'order-list',
    path: '/order/list',
    component: () => import('./view/pages/order/orders/orders'),
    meta: {
      login: true,
      title: '我的行程'
    }
  },
  {
    name: 'vip',
    path: '/vip',
    component: () => import('./view/pages/vip/vip'),
    meta: {
      login: true,
      title: '会员中心'
    }
  },
  {
    name: 'user',
    path: '/user',
    component: () => import('./view/pages/user/center'),
    meta: {
      login: true,
      title: '用户中心'
    }
  },
  {
    name: 'user-profile',
    path: '/user/profile',
    component: () => import('./view/pages/user/profile/profile'),
    meta: {
      login: true,
      title: '账号和个人信息'
    }
  },
  {
    name: 'user-commute',
    path: '/user/commute',
    component: () => import('./view/pages/user/commute/commute'),
    meta: {
      login: true,
      title: '账号和个人信息'
    }
  },
  {
    name: 'setting',
    path: '/setting',
    component: () => import('./view/pages/setting/setting'),
    meta: {
      login: true,
      title: '设置'
    }
  },
  {
    name: 'setting-ride-preference',
    path: '/setting/ride-preference',
    component: () => import('./view/pages/setting/ride-preference/ride-preference'),
    meta: {
      login: true,
      title: '乘车偏好'
    }
  },
  {
    name: 'return-trip',
    path: '/return-trip',
    component: () => import('./view/pages/return-trip/return-trip'),
    meta: {
      login: true,
      title: '回城车',
      keepAlive: true
    }
  },
  {
    name: 'designated-driving',
    path: '/designated-driving',
    component: () => import('./view/pages/designated-driving/designated-driving'),
    meta: {
      login: true,
      title: '找代驾',
      keepAlive: true
    }
  },
  {
    name: 'goto',
    path: '/goto',
    component: () => import('./view/pages/goto/goto'),
    meta: {
      title: '请稍后...'
    }
  },
  {
    name: 'open-wechat-login',
    path: '/open/wechat-login',
    component: () => import('./view/pages/open/wechat-login/wechat-login'),
    meta: {
      title: '请稍后...'
    }
  },
  {
    name: 'open-order-invalid',
    path: '/open/order-invalid',
    component: () => import('./view/pages/open/order-invalid/order-invalid'),
    meta: {
      title: '没有正在进行中的行程'
    }
  }
];

const router = createRouter({
  routes,
  // history: createWebHashHistory(),
  history: createWebHistory()
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  //if (to.meta.login && !SessionUtil.isLogin()) {
  //    RouterUtil.go("/login", false, to.path);
  //    return;
  //}
  next();
});

export { router };
